module.exports = __webpack_public_path__ + "media/components/SaveMoneyMakeMoney/save-money-background-0a58b741d3b4e5e5fef3d8fa75a1686d.png";